import React, { Component } from 'react';
import { CustomInput, Label } from 'reactstrap';
import S3 from 'react-aws-s3';

export default class UploadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        }
    }

    fileDropSubmitToS3 = async (file, sectionName, documentCategory) => {
        const config = {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID,
        };
        const ReactS3Client = new S3(config);
        await ReactS3Client.uploadFile(file, 'testimony/' + this.state.victimId + '/' + sectionName + '/' + documentCategory + '/' + file.name)
            .then(data => {
                if (data && data.location) {
                    this.props.notifyParent(true)
                } else {
                    this.props.notifyParent(false)
                }
            })
            .catch(err => {
                this.props.notifyParent(false)
            });
    };


    fileDropHandling = async (event, sectionName) => {
        if (event.target.files !== null && event.target.files.length > 0) {
            for (let file of event.target.files) {
                await this.fileDropSubmitToS3(file, sectionName, 5);
            }
        }
    };

    render() {
        return (
                <div className="custom-file mb-2" style={{width: '200px'}}>
                    <CustomInput
                        size={this.props.isSmall && "sm"}
                        type="file" multiple 
                        className="custom-file-input"
                        id="tempDocumentFileDropHolder"
                        onChange={event => {
                            this.fileDropHandling(event, 'register');
                        }}
                    />
                    <Label className="custom-file-label" htmlFor="tempDocumentFileDropHolder">
                        Choose files
                    </Label>
                </div>
        )
    }
}